import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Api from "../../services/Api.ts";

interface Props {
    setCustomerName: (name: string) => void;
}

const AcceptInvite = (props: Props) => {
    const api = Api.getInstance()
    const { code } = useParams(); // Extract invite code from URL
    const navigate = useNavigate(); // Hook to navigate programmatically
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const data = {
            code: code
        }
        api.post('customer/accept_invite', data).then(response => {
            setLoading(false)
            if (response.json.status === "ok") {
                props.setCustomerName(response.json.customerName)
                navigate('/')
            } else if (response.json.error) {
                setError(response.json.error)
            } else {
                setError('Unknown error. Please contact support')
            }
        })
    }, [])

    if (loading) return <div>Loading...</div>;
    if (error.length > 0) return <div className="text-center mt-4">Error: {error}</div>;

    return <div>Invite accepted successfully!</div>; // This message will appear briefly before redirecting
};

export default AcceptInvite;